// Where the Photo Booth's files (PDFs) are worked on — the queue in a photo editor points here when it holds files it cannot open.
export const PRINT_READY_PATH = '/tools/image/print-ready-maker';
